import React from 'react'

import { Grid, InlineEdit, Row, Text, Tooltip } from '@plurall/elo-beta'
import PropTypes from 'prop-types'

import styles from '../PersonalData.module.css'

const ToolTipContainer = ({ children, hintText }) =>
  hintText ? (
    <Tooltip position='top' title={hintText}>
      <div>{children}</div>
    </Tooltip>
  ) : (
    children
  )

export const RowWithInput = ({ name, onSave, hintText, disabled, value, ...rest }) => (
  <div className={styles.row}>
    <Grid desktop={3}>
      <Text textTransform='uppercase' size='t5' semibold className={styles.label}>
        {name}
      </Text>
    </Grid>
    <Grid desktop={9}>
      {!disabled ? (
        <InlineEdit onSave={onSave} disabled={disabled} value={value} {...rest} />
      ) : (
        <div className={styles['tooltip-container']}>
          <ToolTipContainer hintText={hintText} value={value}>
            <Text size='t3'>{value}</Text>
          </ToolTipContainer>
        </div>
      )}
    </Grid>
  </div>
)

export const RowWithDialog = ({ name, openDialog, value, dataTestId, disabled }) => (
  <Row>
    <Grid desktop={3} tablet={3} mobile={12}>
      <Text textTransform='uppercase' size='t5' semibold>
        {name}
      </Text>
    </Grid>
    <Grid desktop={9} tablet={9} mobile={6}>
      <div className={styles['content-edit']}>
        <Text>{value}</Text>
        {!disabled && (
          <Text element='a' size='t3' onClick={openDialog} dataTestId={dataTestId}>
            Alterar
          </Text>
        )}
      </div>
    </Grid>
  </Row>
)

ToolTipContainer.propTypes = {
  children: PropTypes.node.isRequired,
  hintText: PropTypes.string,
}

RowWithInput.propTypes = {
  name: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  hintText: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
}

RowWithDialog.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  openDialog: PropTypes.func.isRequired,
  dataTestId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}
